import { render, staticRenderFns } from "./Selectcourse.vue?vue&type=template&id=1aa2cc0d&scoped=true&"
import script from "./Selectcourse.vue?vue&type=script&lang=js&"
export * from "./Selectcourse.vue?vue&type=script&lang=js&"
import style0 from "./Selectcourse.vue?vue&type=style&index=0&id=1aa2cc0d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa2cc0d",
  null
  
)

export default component.exports